import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientLicenseEntity } from './client-license.entity';

@Index('license_note_ibfk_1', ['fkLicenseId'], {})
@Entity('license_note')
export class LicenseNoteEntity extends BaseEntity {
	@Column('int', { name: '_fk_license__id', unsigned: true })
	public fkLicenseId!: number;

	@Column('longtext', { name: 'note' })
	public note!: string;

	@Column({ type: 'boolean', name: 'is_pinned', width: 1, default: 0 })
	public isPinned!: boolean;

	@ManyToOne(() => ClientLicenseEntity, (license) => license.notes, {
		onDelete: 'CASCADE',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: '_fk_license__id', referencedColumnName: 'id' }])
	public fkLicense!: ClientLicenseEntity;
}
